import { pages } from '../routeConfig';
import { AppRoute } from '../RouteRenderer';

export const marketRoutes = [
    {
        path: 'forex/main-currencies',
        element: pages.mainCurrencies,
    },
    {
        path: 'forex/cross-currencies',
        element: pages.crossCurrencies,
    },
    {
        path: 'forex/index-currencies',
        element: pages.indexCurrencies,
    },
    {
        path: 'metals',
        element: pages.metals,
    },
    {
        path: 'crypto',
        element: pages.crypto,
    },
    {
        path: 'indicator',
        element: pages.indicator,
    },
    {
        path: 'stock',
        element: pages.stock,
    },
    {
        path: 'energy',
        element: pages.energy,
    },
    {
        path: 'gold-price',
        element: pages.gold,
    },
    {
        path: 'usd-in-egypt',
        element: pages.bank,
    },
    {
        path: 'black-market-in-egypt',
        element: pages.currency,
    },
]satisfies AppRoute[];